export const RATES = [
	{
		rate: 0.7,
		startDate: "2025-01-01",
		endDate: "2025-12-31",
	},
	{
		rate: 0.67,
		startDate: "2024-01-01",
		endDate: "2024-12-31",
	},
	{
		rate: 0.655,
		startDate: "2023-01-01",
		endDate: "2023-12-31",
	},
	{
		rate: 0.625,
		startDate: "2022-07-01",
		endDate: "2022-12-31",
	},
	{
		rate: 0.585,
		startDate: "2022-01-01",
		endDate: "2022-06-30",
	},
	{
		rate: 0.56,
		startDate: "2021-01-01",
		endDate: "2021-12-31",
	},
	{
		rate: 0.575,
		startDate: "2020-01-01",
		endDate: "2020-12-31",
	},
	{
		rate: 0.58,
		startDate: "2019-01-01",
		endDate: "2019-12-31",
	},
	{
		rate: 0.545,
		startDate: "2018-01-01",
		endDate: "2018-12-31",
	},
	{
		rate: 0.535,
		startDate: "2017-01-01",
		endDate: "2017-12-31",
	},
]